import React from 'react';
import DOMPurify from 'dompurify';
import { useLanguage } from '../../context/LanguageContext';

const AboutSection = () => {
	const { t } = useLanguage();

	const paragraphs = [
		t('about.paragraph1'),
		t('about.paragraph2'),
		t('about.paragraph3'),
		t('about.paragraph4'),
	].filter(Boolean);

	const stats = [
		{ label: t('about.stats.modules'), value: '10+' },
		{ label: t('about.stats.areas'), value: '3' },
		{ label: t('about.stats.satisfaction'), value: '99.9%' },
		{ label: t('about.stats.support'), value: '24/7' }
	];

	return (
		<section id="about" className="landing-section">
			<div className="container-landing">
				<div className="text-center">
					<h2 className="section-title">{t('about.title')}</h2>
					<p className="section-subtitle">{t('about.subtitle')}</p>
				</div>

				<div className="about-content">
					{paragraphs.map((text, index) => (
						<p key={index} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }} />
					))}
				</div>

				<div className="about-stats">
					{stats.map((stat, index) => (
						<div key={index} className="about-stat">
							<div className="about-stat-value">{stat.value}</div>
							<div className="about-stat-label">{stat.label}</div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default AboutSection;
